export const SESSION_SUCCESS = 'session/SESSION_SUCCESS';
export const SESSION_FAILURE = 'session/SESSION_FAILURE';
export const SESSION_REQUEST = 'session/SESSION_REQUEST';
export const INSERT_PARTIALS = 'session/INSERT_PARTIALS';
